import Route from '@ember/routing/route';

export default class EngageRoute extends Route {}
